var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex align-items-center text-dark border-bottom py-2 cursor-pointer",
    class: [_vm.isSelected ? 'spnod-message__selected' : 'spnod-message__item'],
    on: {
      "click": function($event) {
        return _vm.$emit('changeMessage', {
          index: _vm.index,
          message: _vm.message
        })
      }
    }
  }, [_c('div', {
    staticClass: "spnod-message-summary__icon fi px-2",
    class: [_vm.flatIcon, _vm.isSelected ? 'text-white' : '']
  }, [(_vm.avatar) ? _c('img', {
    staticClass: "rounded-circle",
    attrs: {
      "src": _vm.avatar,
      "width": "32",
      "height": "32"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-block text-truncate",
    class: [_vm.message.totalMessagesUnreadByMe > 0 ? 'spnod-text--bold' : '', _vm.isSelected ? 'text-white' : '']
  }, [_c('div', {
    staticClass: "pb-1"
  }, _vm._l((_vm.message.participants), function(participant, participantIndex) {
    return _c('span', {
      key: participantIndex,
      staticClass: "spnod-message-summary__participant",
      class: {
        'spnod-message__participant--inactive': participant.inActive
      }
    }, [_vm._v("\n        " + _vm._s(participant.name) + _vm._s(participantIndex != _vm.message.participants.length - 1 ? ', ' : '') + "\n      ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "d-block text-truncate"
  }, [_vm._v(_vm._s(_vm.message.lastMessage))])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-611e2580","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Messaging/Message.vue
// module id = qOkz
// module chunks = 2